/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Label_SeniorityInputs */

const en_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniority Level`)
};

const de_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrungsstufe`)
};

const fr_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau d'expérience`)
};

const es_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de experiencia`)
};

const it_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello di seniority`)
};

const nl_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioriteitsniveau`)
};

const pl_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziom doświadczenia`)
};

const fi_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokemus­taso`)
};

const da_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioritetsniveau`)
};

const sv_interview_qbank_label_seniority = /** @type {(inputs: Interview_Qbank_Label_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioritetsnivå`)
};

/**
* | output |
* | --- |
* | "Seniority Level" |
*
* @param {Interview_Qbank_Label_SeniorityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_label_seniority = /** @type {((inputs?: Interview_Qbank_Label_SeniorityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Label_SeniorityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_label_seniority(inputs)
	if (locale === "fr") return fr_interview_qbank_label_seniority(inputs)
	if (locale === "es") return es_interview_qbank_label_seniority(inputs)
	if (locale === "it") return it_interview_qbank_label_seniority(inputs)
	if (locale === "nl") return nl_interview_qbank_label_seniority(inputs)
	if (locale === "pl") return pl_interview_qbank_label_seniority(inputs)
	if (locale === "fi") return fi_interview_qbank_label_seniority(inputs)
	if (locale === "da") return da_interview_qbank_label_seniority(inputs)
	if (locale === "sv") return sv_interview_qbank_label_seniority(inputs)
	return en_interview_qbank_label_seniority(inputs)
});